export default class Pageable {

  constructor(resource) {
    this.resource = resource;
    this.pageSize = 50;
    this.page = 1;
    this.entries = [];
    this.moreToAppend = true;
    this.resolved = true;
  }

  refresh(params) {
    if (!this.moreToAppend) {
      return;
    }

    this.params = params;
    this.params.skip = this.pageSize * (this.page - 1);
    this.params.take = this.pageSize + 1;

    this.resolved = false;

    this.resource
      .query(params)
      .$promise
      .then((result) => {
        this.moreToAppend = result.length === this.pageSize + 1;
        if (this.moreToAppend) {
          result.pop();
        }
        this.entries = this.entries.concat(result);
        this.resolved = true;
      });
  }

  nextPage() {
    if (this.moreToAppend) {
      this.page++;
      this.refresh(this.params);
    }
  }
}



// WEBPACK FOOTER //
// ./app/Pageable.js